import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import {
    clearSidebarStateForViewport,
    closeMobileSidebar,
    ensureSidebarOverlay,
    toggleMiniSidebar,
} from './layoutUtils'
import { getStoredUser, getUserDisplayName, signOut } from '../../config/authUtils'

const Sidebar = () => {
    const location = useLocation()
    const navigate = useNavigate()

    const isActive = (path) => location.pathname === path

    const [openSubmenus, setOpenSubmenus] = useState({
        employees:
            location.pathname.startsWith('/coo/employees') ||
            location.pathname.startsWith('/coo/add-employee') ||
            location.pathname.startsWith('/coo/hods-improvement-plans'),
        kra: location.pathname.startsWith('/coo/key-result-areas') ||
            location.pathname.startsWith('/coo/create-key-result-area'),
        myGoals:
            location.pathname.startsWith('/coo/create-goal') ||
            location.pathname.startsWith('/coo/import-kpis') ||
            location.pathname.startsWith('/coo/goals'),
        myIps:
            location.pathname.startsWith('/coo/create-improvement-plan') ||
            location.pathname.startsWith('/coo/improvement-plans'),
    })

    useEffect(() => {
        setOpenSubmenus({
            employees:
                location.pathname.startsWith('/coo/employees') ||
                location.pathname.startsWith('/coo/add-employee') ||
                location.pathname.startsWith('/coo/hods-improvement-plans'),
            kra: location.pathname.startsWith('/coo/key-result-areas') ||
                location.pathname.startsWith('/coo/create-key-result-area'),
            myGoals:
                location.pathname.startsWith('/coo/create-goal') ||
                location.pathname.startsWith('/coo/import-kpis') ||
                location.pathname.startsWith('/coo/goals'),
            myIps:
                location.pathname.startsWith('/coo/create-improvement-plan') ||
                location.pathname.startsWith('/coo/improvement-plans'),
        })
    }, [location.pathname])

    const toggleSubmenu = (menuKey) => {
        setOpenSubmenus((prev) => ({
            ...prev,
            [menuKey]: !prev[menuKey],
        }))
    }

    useEffect(() => {
        const overlay = ensureSidebarOverlay()
        const handleOverlayClick = () => closeMobileSidebar()
        overlay?.addEventListener('click', handleOverlayClick)
        return () => overlay?.removeEventListener('click', handleOverlayClick)
    }, [])

    useEffect(() => {
        clearSidebarStateForViewport()
        let resizeTimeout
        const handleResize = () => {
            clearTimeout(resizeTimeout)
            resizeTimeout = setTimeout(clearSidebarStateForViewport, 100)
        }
        window.addEventListener('resize', handleResize)
        return () => {
            clearTimeout(resizeTimeout)
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    useEffect(() => {
        closeMobileSidebar()
    }, [location.pathname])

    const storedUser = getStoredUser()

    const handleLogout = () => {
        signOut()
        closeMobileSidebar()
        navigate('/lockscreen', { replace: true })
    }

    const navLinkClass = (path) => (isActive(path) ? 'active' : '')

    return (
        <div className="main-wrapper">
            <div
                className="sidebar shadow-sm"
                id="sidebar"
                style={{
                    borderRight: '1px solid rgba(0,0,0,0.05)',
                    backgroundColor: 'var(--bs-body-bg)',
                }}
            >
                <div
                    className="sidebar-logo border-bottom"
                    style={{ borderColor: 'rgba(0,0,0,0.05)' }}
                >
                    <div>
                        <Link to="/coo/dashboard" className="logo logo-normal mt-3">
                            <img
                                style={{
                                    height: '80px',
                                    width: '150px',
                                    objectFit: 'contain',
                                }}
                                src="assets/img/media/celebration-dark.png"
                                alt="Logo"
                            />
                        </Link>
                        <Link to="/coo/dashboard" className="logo-small">
                            <img
                                style={{
                                    height: '65px',
                                    width: '150px',
                                    objectFit: 'contain',
                                }}
                                src="assets/img/media/celebration-dark.png"
                                alt="Logo"
                            />
                        </Link>
                        <Link to="/coo/dashboard" className="dark-logo">
                            <img src="assets/img/media/celebration-light.png" alt="Logo" />
                        </Link>
                    </div>
                    <button
                        type="button"
                        className="sidenav-toggle-btn btn p-0"
                        id="toggle_btn"
                        onClick={toggleMiniSidebar}
                        aria-label="Toggle sidebar"
                    >
                        <i className="ti ti-chevron-left-pipe" />
                    </button>
                    <button
                        type="button"
                        className="sidebar-close"
                        onClick={closeMobileSidebar}
                        aria-label="Close sidebar"
                    >
                        <i className="ti ti-x align-middle" />
                    </button>
                </div>

                <div
                    className="sidebar-inner"
                    style={{
                        overflowY: 'auto',
                        height: 'calc(100vh - 60px)',
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <div id="sidebar-menu" className="sidebar-menu flex-grow-1">
                        <ul className="pt-3">
                            <li className="menu-title">
                                <span className="fw-semibold text-uppercase tracking-wider opacity-75">
                                    Main Menu
                                </span>
                            </li>
                            <li>
                                <ul>
                                    <li>
                                        <Link
                                            to="/coo/dashboard"
                                            className={navLinkClass('/coo/dashboard')}
                                        >
                                            <i className="ti ti-layout-dashboard" />
                                            <span>Dashboard</span>
                                        </Link>
                                    </li>

                                    <li className="submenu">
                                        <Link
                                            to="#"
                                            className={`${
                                                location.pathname.startsWith('/coo/employees') ||
                                                location.pathname.startsWith('/coo/employees/add') ||
                                                location.pathname.startsWith('/coo/hods-improvement-plans')
                                                    ? 'active'
                                                    : ''
                                            } ${openSubmenus.employees ? 'subdrop' : ''}`}
                                            onClick={(e) => {
                                                e.preventDefault()
                                                toggleSubmenu('employees')
                                            }}
                                        >
                                            <i className="ti ti-users" />
                                            <span>Employees</span>
                                            <span className="menu-arrow" />
                                        </Link>
                                        <ul style={{ display: openSubmenus.employees ? 'block' : 'none' }}>
                                            <li>
                                                <Link
                                                    to="/coo/employees"
                                                    className={navLinkClass('/coo/employees')}
                                                >
                                                    <span>View Employees</span>
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    to="/coo/employees/add"
                                                    className={navLinkClass('/coo/employees/add')}
                                                >
                                                    <span>Add Employee</span>
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    to="/coo/hods-improvement-plans"
                                                    className={navLinkClass('/coo/hods-improvement-plans')}
                                                >
                                                    <span>Improvement Plans</span>
                                                </Link>
                                            </li>
                                        </ul>
                                    </li>

                                    <li className="submenu">
                                        <Link
                                            to="#"
                                            className={`${
                                                location.pathname.startsWith('/coo/key-result-areas') ||
                                                location.pathname.startsWith('/coo/create-key-result-area')
                                                    ? 'active'
                                                    : ''
                                            } ${openSubmenus.kra ? 'subdrop' : ''}`}
                                            onClick={(e) => {
                                                e.preventDefault()
                                                toggleSubmenu('kra')
                                            }}
                                        >
                                            <i className="ti ti-briefcase" />
                                            <span>Key Result Areas</span>
                                            <span className="menu-arrow" />
                                        </Link>
                                        <ul style={{ display: openSubmenus.kra ? 'block' : 'none' }}>
                                            <li>
                                                <Link
                                                    to="/coo/create-key-result-area"
                                                    className={navLinkClass('/coo/create-key-result-area')}
                                                >
                                                    <span>Add KRA</span>
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    to="/coo/key-result-areas"
                                                    className={navLinkClass('/coo/key-result-areas')}
                                                >
                                                    <span>View KRAs</span>
                                                </Link>
                                            </li>
                                        </ul>
                                    </li>

                                    <li className="submenu">
                                        <Link
                                            to="#"
                                            className={`${
                                                location.pathname.startsWith('/coo/kpis/add') ||
                                                location.pathname.startsWith('/coo/kpis')
                                                    ? 'active'
                                                    : ''
                                            } ${openSubmenus.myGoals ? 'subdrop' : ''}`}
                                            onClick={(e) => {
                                                e.preventDefault()
                                                toggleSubmenu('myGoals')
                                            }}
                                        >
                                            <i className="ti ti-target" />
                                            <span>My KPIs</span>
                                            <span className="menu-arrow" />
                                        </Link>
                                        <ul style={{ display: openSubmenus.myGoals ? 'block' : 'none' }}>
                                            <li>
                                                <Link
                                                    to="/coo/kpis/add"
                                                    className={navLinkClass('/coo/kpis/add')}
                                                >
                                                    <span>Create KPI</span>
                                                </Link>
                                            </li>
                                            
                                            <li>
                                                <Link
                                                    to="/coo/kpis"
                                                    className={navLinkClass('/coo/kpis')}
                                                >
                                                    <span>View KPIs</span>
                                                </Link>
                                            </li>
                                        </ul>
                                    </li>

                                    <li>
                                        <Link
                                            to="/coo/my-goals-reviews"
                                            className={navLinkClass('/coo/my-goals-reviews')}
                                        >
                                            <i className="ti ti-list-check" />
                                            <span>My KPIs Reviews</span>
                                        </Link>
                                    </li>

                                    <li className="submenu">
                                        <Link
                                            to="#"
                                            className={`${
                                                location.pathname.startsWith('/coo/create-improvement-plan') ||
                                                location.pathname.startsWith('/coo/improvement-plans')
                                                    ? 'active'
                                                    : ''
                                            } ${openSubmenus.myIps ? 'subdrop' : ''}`}
                                            onClick={(e) => {
                                                e.preventDefault()
                                                toggleSubmenu('myIps')
                                            }}
                                        >
                                            <i className="ti ti-school" />
                                            <span>Improvement Plans</span>
                                            <span className="menu-arrow" />
                                        </Link>
                                        <ul style={{ display: openSubmenus.myIps ? 'block' : 'none' }}>
                                            <li>
                                                <Link
                                                    to="/coo/create-improvement-plan"
                                                    className={navLinkClass('/coo/create-improvement-plan')}
                                                >
                                                    <span>Create IP</span>
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    to="/coo/improvement-plans"
                                                    className={navLinkClass('/coo/improvement-plans')}
                                                >
                                                    <span>View IPs</span>
                                                </Link>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>

                            <li className="menu-title mt-4">
                                <span className="fw-semibold text-uppercase tracking-wider opacity-75">
                                    Personal
                                </span>
                            </li>
                            <li>
                                <ul>
                                    <li>
                                        <Link
                                            to="/coo/two-factor-authentication"
                                            className={navLinkClass('/coo/two-factor-authentication')}
                                        >
                                            <i className="ti ti-shield" />
                                            <span>Two-Factor Auth</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            to="/coo/change-password"
                                            className={navLinkClass('/coo/change-password')}
                                        >
                                            <i className="ti ti-lock" />
                                            <span>Change Password</span>
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>

                    <div
                        className="sidebar-footer mt-auto p-3 border-top"
                        style={{
                            borderColor: 'rgba(0,0,0,0.05)',
                            backgroundColor: 'var(--bs-body-bg)',
                        }}
                    >
                        <div
                            className="p-2 mb-3 rounded-3 d-flex align-items-center"
                            style={{
                                backgroundColor: 'var(--bs-light)',
                                border: '1px solid rgba(0,0,0,0.05)',
                                transition: 'all 0.3s ease',
                            }}
                        >
                            <span className="avatar avatar-md me-3 shadow-sm rounded-circle border border-white d-flex align-items-center justify-content-center fw-bold text-white"
                                style={{ backgroundColor: '#4F46E5', minWidth: '42px' }}>
                                {(getUserDisplayName(storedUser) || storedUser?.email || 'C')
                                    .charAt(0)
                                    .toUpperCase()}
                            </span>
                            <div className="overflow-hidden">
                                <h6 className="fs-14 fw-bold mb-0 text-truncate">
                                    {getUserDisplayName(storedUser)}
                                </h6>
                                <p className="fs-12 text-muted mb-0 text-truncate">
                                    {storedUser?.role_display}
                                </p>
                            </div>
                        </div>
                        <button
                            type="button"
                            className="btn w-100 d-flex align-items-center justify-content-center fw-medium shadow-sm transition-all"
                            onClick={handleLogout}
                            style={{
                                backgroundColor: '#fff0f0',
                                color: '#dc3545',
                                border: '1px solid #ffdcdc',
                            }}
                            onMouseOver={(e) => {
                                e.currentTarget.style.backgroundColor = '#dc3545'
                                e.currentTarget.style.color = '#fff'
                            }}
                            onMouseOut={(e) => {
                                e.currentTarget.style.backgroundColor = '#fff0f0'
                                e.currentTarget.style.color = '#dc3545'
                            }}
                        >
                            <i className="ti ti-logout-2 me-2 fs-16" />
                            Logout
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Sidebar
